import script from "./DatasetSearchLandingUI.vue?vue&type=script&setup=true&lang=js"
export * from "./DatasetSearchLandingUI.vue?vue&type=script&setup=true&lang=js"

import "./DatasetSearchLandingUI.vue?vue&type=style&index=0&id=a11b9dcc&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a11b9dcc"]])

export default __exports__